import type React from 'react'

const activateOnEnterOrSpace =
  <T extends HTMLElement = HTMLElement>(activate: () => void) =>
  (event: React.KeyboardEvent<T>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      activate()
    }
  }

export default activateOnEnterOrSpace
